import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDiffValues<T extends Record<string, any>>(originalValues: T, newValues: T) {
  const diffKeys = Object.keys(originalValues).filter(
    (key) => originalValues[key] !== newValues[key]
  );
  return diffKeys.reduce((acc, key) => {
    acc[key] = newValues[key];
    return acc;
  }, {} as Record<string, any>);
}
